import {ReactMarkdownProps} from 'react-markdown/lib/ast-to-react';

import {Modal, Text} from '#component/base';
import {Markdown} from '#component/partial/Markdown';
import {ListItem} from '#component/partial/Markdown/component/ListItem';
import {Paragraph} from '#component/partial/Markdown/component/Paragraph';
import {sprinkles} from '#style/sprinkles';

import {ActionItemModalProps} from './ActionItemModal.types';

import * as css from './ActionItemModal.css';

export const ActionItemModal = ({headline, content}: ActionItemModalProps) => (
  <Modal
    header={
      <Text
        className={sprinkles({flex: 'flex', h: 'full', items: 'center'})}
        color="mineShaft"
        variant="heading4">
        {headline}
      </Text>
    }
    layout="drawer">
    <Markdown
      className={sprinkles({flex: 'flex', dir: 'col', gap: 16})}
      components={{
        p: (props: ReactMarkdownProps) => <Paragraph {...props} />,
        li: (props: ReactMarkdownProps) => (
          <ListItem color="mineShaft" className={css.listItem} {...props} />
        ),
        ul: (props: ReactMarkdownProps) => <Text as="ul" {...props} />,
      }}
      data={content || ''}
    />
  </Modal>
);
